// Action bar: PDF download + Request implementation. Verbatim from
// PaidReport.jsx (W2c). The buttons and the inline error span layout
// is preserved exactly (same flex, same gap, same wrap behavior).
export default function ReportActionBar({
  pdfBusy,
  pdfError,
  onDownloadPdf,
  onRequestImplementation,
}) {
  return (
    <div
      className="sf-card"
      style={{ marginBottom: 36, display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}
      data-testid="paid-report-actions"
    >
      <button type="button" className="sf-btn" onClick={onDownloadPdf} disabled={pdfBusy} data-testid="paid-report-pdf-btn">
        {pdfBusy ? "Generating PDF…" : "Download PDF"}
      </button>
      <button type="button" className="sf-btn-secondary" onClick={onRequestImplementation} data-testid="paid-report-impl-btn">
        Request implementation
      </button>
      {pdfError && <span className="sf-mono" style={{ color: "#e2867e", fontSize: 13 }} data-testid="paid-report-pdf-error">{pdfError}</span>}
    </div>
  );
}
